import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import type { ChatPageState } from "web_myplann/Chat/Hooks/useChatPage";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import type { AgentChatTarget } from "web_myplann/Shared/Types/AgentChatTarget";
import { device } from "web_myplann/Utils/device";

export const useOpenAgentChat = () => {
	const navigate = useNavigate();
	const hasGoalsRight = useGoalsRightOptional();

	return useCallback(
		({ uid, title, conversationId, message }: AgentChatTarget) => {
			if (hasGoalsRight) {
				navigate(
					Routing.Chat.Detail.path(
						conversationId ? String(conversationId) : "new",
						uid,
					),
					{ state: { draftMessage: message } satisfies ChatPageState },
				);
				return;
			}

			device.navigateChatRequest(
				String(conversationId ?? ""),
				title,
				uid,
				message,
			);
		},
		[navigate, hasGoalsRight],
	);
};
